import { createAdminApiClient } from '../adminApiClient';

/**
 * Service para deportistas (bases) en admin.
 * Reemplaza los Vuex actions de back.bases.*
 */
export default {
    /**
     * Obtiene los datos de un deportista.
     * GET /listas-abonados/{lista_id}/bases/{base_id}
     *
     * @param {{ lista_id: number|string, base_id: number|string }} params
     * @returns {Promise<Object>}
     */
    async getBase({ lista_id, base_id }) {
        const client = createAdminApiClient();

        const response = await client.get(`/listas-abonados/${lista_id}/bases/${base_id}`);

        return response.data ?? {};
    },

    /**
     * Actualiza los datos de un deportista.
     * PATCH /listas-abonados/{lista_id}/bases/{base_id}/update
     *
     * @param {Object} data — incluye base_id, lista_id y los campos a actualizar
     * @returns {Promise<Object>}
     */
    async updateBase(data) {
        const client = createAdminApiClient();

        const { base_id, lista_id, ...body } = data;

        const response = await client.patch(
            `/listas-abonados/${lista_id}/bases/${base_id}/update`,
            body,
            { params: { lista_id } },
        );

        return response.data ?? {};
    },

    /**
     * Obtiene la lista de equipos disponibles.
     * GET /listas-abonados/{lista_id}/bases/equipos
     *
     * @param {{ lista_id: number|string }} params
     * @returns {Promise<Array>}
     */
    async getEquipos({ lista_id }) {
        const client = createAdminApiClient();

        const response = await client.get(`/listas-abonados/${lista_id}/bases/equipos`);

        const data = response.data ?? {};
        return data.data ?? [];
    },
};
